const { cELM } = require("../../utils");
const { BUCKET_IMAGES_URL } = require('../../utils/constants');
const Chat = require("../../chat");

class Confirm {
  constructor(data, callback, matchingAns) {
    this._data = data;
    this.options = data.values.split("|");
    this.matchingAns = matchingAns;
    this.element = cELM("div", "option-block option-block-confirm");
    this.callback = callback;
  }

  getELM() {
    return this.element;
  }

  getHTML() {
    var _self = this;
    var row = cELM("div", "row row-buttons");

    const cancelButton = cELM("div", "button-cancel", this.options[0]);
    cancelButton.onclick = function(evt) {
      Chat.default.send('cancel', null, cancelButton);

      if (_self.callback) {
        _self.callback('cancel');
      }
    };

    row.addELM(cancelButton);

    const okButton = cELM("div", "button-ok", this.options[1]);
    const arrow = cELM('div', 'arrow-target arrow-active');
    arrow.addELM(okButton);
    const img = cELM('img', 'arrow');
    img.src = `${BUCKET_IMAGES_URL}/ui-assets/arrow.svg`;
    arrow.addELM(img);

    okButton.onclick = function(evt) {
      Chat.default.send('ok', null, okButton);

      if (_self.callback) {
        _self.callback('ok');
      }
    }

    row.addELM(arrow);

    this.element.addELM(row)
    return this.element;
  }

  reset() {}
  focus() {}
}

module.exports = Confirm;
